import React from "react";
import styles from "../../styles/landing.module.css";

const ScientificBackSection = ({ id }) => {
  return (
    <section className={styles.scientificBackSection} id={id}>
      <h2>Scientific Background</h2>
      
      <div className={styles.scientificContent}>
        <div className={styles.scientificText}>
          <h3 style={{ marginBottom: '0.5rem' }}>Ebbinghaus' Forgetting Curve</h3>
          <p>
            In the 19th century, psychologist Hermann Ebbinghaus discovered that our memory 
            follows a predictable curve: we forget information rapidly after 
            initial learning, then the rate of forgetting slows over time.
          </p>
          
          <h3 style={{ marginTop: '2rem', marginBottom: '0.5rem' }}>Spaced Repetition</h3>
          <p>
            Scientific research has shown that reviewing information just before 
            it's forgotten strengthens its memorization exponentially. 
            This is the principle of spaced repetition, which has been validated by research such as 
            the study "<a href="https://www.researchgate.net/publication/15174960_Optimization_of_repetition_spacing_in_the_practice_of_learning" target="_blank" rel="noopener noreferrer">Optimization of repetition spacing in the practice of learning</a>".
          </p>
          
          <h3 style={{ marginTop: '2rem', marginBottom: '0.5rem' }}>Our Algorithm</h3>
          <p>
            Memory Curve uses a sophisticated algorithm that calculates the optimal moments 
            for your revisions based on your personal learning curve, 
            maximizing long-term retention while minimizing study time.
          </p>
        </div>
        
        <div className={styles.scientificImage}>
          <img 
            src="/curve.png" 
            alt="Ebbinghaus' Forgetting Curve and Spaced Repetition" 
            className={styles.sectionImage}
          />
          <p className={styles.imageCaption}>
          This graph shows how memory retention declines over time after first learning something, and how spaced repetition can significantly boost retention and slow forgetting
          </p>
        </div>
      </div>
    </section>
  );
};

export default ScientificBackSection; 